const GAP = 8
const MARGIN = 8

// Computes a viewport-clamped position for the info card relative to its trigger.
// Prefers placing the card to the right of the trigger; flips left near the right
// edge; clamps the top so the card stays fully on screen. Coordinates are
// viewport-relative (for use with position: fixed).
export const cardPlacement = (trigger, cardSize, viewport) => {
  const rightLeft = trigger.right + GAP
  const fitsRight = rightLeft + cardSize.width <= viewport.width - MARGIN

  const placement = fitsRight ? 'right' : 'left'
  const left = fitsRight ? rightLeft : trigger.left - GAP - cardSize.width

  const maxTop = viewport.height - cardSize.height - MARGIN
  const top = Math.max(MARGIN, Math.min(trigger.top, maxTop))

  return { top, left, placement }
}
